import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import queryString from 'query-string'

import { PaymentComp } from 'components/forms'
import { wizard } from 'helpers/decorators'
import { Title, Button, FormDebug } from 'components/misc'
import validate from './payment.validation'
import { apiNextLevel } from 'helpers/decorators/api'
import config from 'config'

@apiNextLevel()
@wizard({
  form: 'nextLevelRegistration',
  multipage: true,
  destroyOnUnmount: false,
  validate
})
class Payment extends Component {
  static propTypes = {
    errors: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onGetPaymentOptions: PropTypes.func.isRequired,
    onPaymentInitialization: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    values: PropTypes.object,
    nextLevel: PropTypes.object,
    getRegistrationInfo: PropTypes.func.isRequired,
    location: PropTypes.object,
    notification: PropTypes.func.isRequired,
  }

  componentDidMount = async () => {
    const {
      getRegistrationInfo,
      values,
      onGetPaymentOptions
    } = this.props

    const query = queryString.parse(get(this.props, 'location.search'))
    const authorizationCode = get(query, 'authorizationCode')

    if (authorizationCode && values) {
      try {
        const res = await getRegistrationInfo(authorizationCode)
        const body = JSON.parse(res.body) || {}

        const previousAwardLevel = get(body, 'previousCompletedAwardLevelInSystem')

        const { awardLevel, organizationId } = values

        await onGetPaymentOptions({
          awardLevel: awardLevel.value,
          organizationId,
          isDirectLevelRegistration: false,
          previousAwardLevel: previousAwardLevel
        })
      }
      catch (err) {
        const errorCode = get(err, 'body') && JSON.parse(err.body).errorCode

        if (errorCode === 'UNAUTHORIZED') {
          this.props.notification(
            'Authorisation code is not valid - it looks like you have previously used this code',
            {
              intlKey: 'notifications.authorization_code_is_not_valid',
              status: 'error'
            }
          )
          this.props.push(`${config.publicPath}/`)
        }
      }
    }
  }

  render() {
    const {
      onPaymentInitialization,
      handleSubmit,
      values,
      change,
      errors,
      nextLevel,
      onSubmit
    } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Title h1>
          <FormattedMessage id="wizard.payment" defaultMessage="Payment" />
        </Title>

        <PaymentComp
          onPaymentInitialization={onPaymentInitialization}
          change={change}
          paymentOptions={get(nextLevel, 'paymentOptions')}
          errors={errors}
          values={values}
        />
        <FormDebug {...this.props} />
        <Button>
          <FormattedMessage id="button.continue" defaultMessage="Continue" />
        </Button>
      </form>
    )
  }
}

export default Payment
